var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDrag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 16,
    viewBox: "0 0 10 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.33333 13.8333C3.33333 14.7533 2.5875 15.5 1.66667 15.5C0.745833 15.5 0 14.7533 0 13.8333C0 12.9133 0.745833 12.1667 1.66667 12.1667C2.5875 12.1667 3.33333 12.9133 3.33333 13.8333ZM1.66667 6.33333C0.745833 6.33333 0 7.08 0 8C0 8.92 0.745833 9.66667 1.66667 9.66667C2.5875 9.66667 3.33333 8.92 3.33333 8C3.33333 7.08 2.5875 6.33333 1.66667 6.33333ZM1.66667 0.5C0.745833 0.5 0 1.24667 0 2.16667C0 3.08667 0.745833 3.83333 1.66667 3.83333C2.5875 3.83333 3.33333 3.08667 3.33333 2.16667C3.33333 1.24667 2.5875 0.5 1.66667 0.5ZM8.33333 12.1667C7.4125 12.1667 6.66667 12.9133 6.66667 13.8333C6.66667 14.7533 7.4125 15.5 8.33333 15.5C9.25417 15.5 10 14.7533 10 13.8333C10 12.9133 9.25417 12.1667 8.33333 12.1667ZM8.33333 6.33333C7.4125 6.33333 6.66667 7.08 6.66667 8C6.66667 8.92 7.4125 9.66667 8.33333 9.66667C9.25417 9.66667 10 8.92 10 8C10 7.08 9.25417 6.33333 8.33333 6.33333ZM8.33333 0.5C7.4125 0.5 6.66667 1.24667 6.66667 2.16667C6.66667 3.08667 7.4125 3.83333 8.33333 3.83333C9.25417 3.83333 10 3.08667 10 2.16667C10 1.24667 9.25417 0.5 8.33333 0.5Z",
    fill: "#8C9196"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrag);
export default __webpack_public_path__ + "static/media/drag.353d6832d55dca4c36ce0eb327af75d2.svg";
export { ForwardRef as ReactComponent };